import { render } from "./JournalView.vue?vue&type=template&id=288b42d8&scoped=true"
import script from "./JournalView.vue?vue&type=script&lang=js"
export * from "./JournalView.vue?vue&type=script&lang=js"

import "./JournalView.vue?vue&type=style&index=0&id=288b42d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288b42d8"]])

export default __exports__